<div
	id="kt_app_sidebar_menu_scroll"
	class="scroll-y my-5 px-3"
	data-kt-scroll="true"
	data-kt-scroll-activate="true"
	data-kt-scroll-height="auto"
	data-kt-scroll-dependencies="#kt_app_sidebar_logo, #kt_app_sidebar_footer"
	data-kt-scroll-wrappers="#kt_app_sidebar_menu"
	data-kt-scroll-offset="5px"
	data-kt-scroll-save-state="true"
>
	<div class="menu menu-column menu-rounded menu-sub-indention fw-semibold fs-6" id="#kt_app_sidebar_menu" data-kt-menu="true" data-kt-menu-expand="false">
		<!-- Separator -->
		<div class="menu-item">
			<div class="menu-content pt-2 pb-2">
				<span class="menu-section text-muted text-uppercase fs-8 ls-1" translate>sidebarMenu</span>
			</div>
		</div>

		<!-- PWA -->
		<div class="menu-item">
			<a class="menu-link without-sub" aria-label="generic" routerLinkActive="active" routerLink="pwa">
				<span class="menu-icon">
					<app-keenicon name="technology-4" class="fs-2"></app-keenicon>
				</span>
				<span class="menu-title" translate>menu_pwa</span>
			</a>
		</div>
		
			<!-- Separator -->
		<div class="menu-item">
			<div class="menu-content pt-2 pb-2">
				<span class="menu-section text-muted text-uppercase fs-8 ls-1" translate>sidebar_more</span>
			</div>
		</div>

		<!-- Files -->
		<div class="menu-item">
			<a class="menu-link without-sub" aria-label="generic" routerLinkActive="active" routerLink="files">
				<span class="menu-icon">
					<app-keenicon name="technology-4" class="fs-2"></app-keenicon>
				</span>
				<span class="menu-title" translate>menu_files</span>
			</a>
		</div>
	</div>
</div>
